export function fmt(n) {
  const v = Number(n || 0);
  return "₹" + v.toLocaleString("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
}

let DATE_FORMAT = (() => { try { return localStorage.getItem("date_format") || "DD/MM/YYYY"; } catch { return "DD/MM/YYYY"; } })();
export function setDateFormat(f) { DATE_FORMAT = f || "DD/MM/YYYY"; try { localStorage.setItem("date_format", DATE_FORMAT); } catch { /* ignore */ } }
export function getDateFormat() { return DATE_FORMAT; }
const _MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export function fmtDate(value) {
  if (!value) return "";
  const s = String(value);
  let y, m, d;
  const iso = s.slice(0, 10).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (iso) { y = +iso[1]; m = +iso[2]; d = +iso[3]; }
  else { const dt = new Date(s); if (isNaN(dt.getTime())) return s; y = dt.getFullYear(); m = dt.getMonth() + 1; d = dt.getDate(); }
  const p = (n) => String(n).padStart(2, "0");
  const DD = p(d), MM = p(m), YYYY = String(y), MMM = _MONTHS[m - 1];
  switch (DATE_FORMAT) {
    case "MM/DD/YYYY": return `${MM}/${DD}/${YYYY}`;
    case "YYYY-MM-DD": return `${YYYY}-${MM}-${DD}`;
    case "DD-MM-YYYY": return `${DD}-${MM}-${YYYY}`;
    case "DD.MM.YYYY": return `${DD}.${MM}.${YYYY}`;
    case "DD MMM YYYY": return `${DD} ${MMM} ${YYYY}`;
    case "MMM DD, YYYY": return `${MMM} ${DD}, ${YYYY}`;
    default: return `${DD}/${MM}/${YYYY}`;
  }
}

export function hasPerm(user, perm) {
  if (!user) return false;
  if (!perm) return true;
  if (user.role === "admin" || user.role === "super_admin") return true;
  return (user.permissions || []).includes(perm);
}

export function initials(name) {
  return (name || "?")
    .split(" ")
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();
}

export const TAG_COLORS = {
  slate: "text-slate-700 bg-slate-100 border-slate-200",
  red: "text-red-700 bg-red-50 border-red-200",
  orange: "text-orange-700 bg-orange-50 border-orange-200",
  amber: "text-amber-700 bg-amber-50 border-amber-200",
  green: "text-emerald-700 bg-emerald-50 border-emerald-200",
  teal: "text-teal-700 bg-teal-50 border-teal-200",
  blue: "text-blue-700 bg-blue-50 border-blue-200",
  indigo: "text-indigo-700 bg-indigo-50 border-indigo-200",
  violet: "text-violet-700 bg-violet-50 border-violet-200",
  pink: "text-pink-700 bg-pink-50 border-pink-200",
  rose: "text-rose-700 bg-rose-50 border-rose-200",
  cyan: "text-cyan-700 bg-cyan-50 border-cyan-200",
};
export const TAG_DOT = {
  slate: "bg-slate-400", red: "bg-red-500", orange: "bg-orange-500", amber: "bg-amber-500",
  green: "bg-emerald-500", teal: "bg-teal-500", blue: "bg-blue-500", indigo: "bg-indigo-500",
  violet: "bg-violet-500", pink: "bg-pink-500", rose: "bg-rose-500", cyan: "bg-cyan-500",
};
export const TAG_COLOR_KEYS = Object.keys(TAG_COLORS);
const KNOWN_TAG = { Topper: "green", Good: "blue", Average: "amber", Defaulter: "rose", New: "indigo" };

export function tagColorKey(name, colors = {}) {
  if (colors[name] && TAG_COLORS[colors[name]]) return colors[name];
  if (KNOWN_TAG[name]) return KNOWN_TAG[name];
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return TAG_COLOR_KEYS[h % TAG_COLOR_KEYS.length];
}

export function tagColorClass(name, colors = {}) {
  return TAG_COLORS[tagColorKey(name, colors)];
}
